"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareArcxLoggerStub = void 0;
const src_1 = require("../../src");
function prepareArcxLoggerStub() {
    const arcxLogger = new src_1.ArcxLogger({
        accessToken: 'noProject',
        captureUncaught: true,
        captureUnhandledRejections: true,
        environment: 'test',
    });
    arcxLogger.setTestEnvironment();
    return arcxLogger;
}
exports.prepareArcxLoggerStub = prepareArcxLoggerStub;
//# sourceMappingURL=prepareArcxLoggerStub.js.map